module.exports = __webpack_public_path__ + "media/tower.3a896852.mp4";